import { combineReducers } from 'redux'
import { voicemail } from './voicemail'
import { currentTab } from './personal-settings'

export default combineReducers({
    voicemail,
    currentTab
})